import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import { ISecretChatAccessRequest } from 'APP/model/e2ee/e2eeModel.types';
import Entities from 'STORE';
import { User } from 'STORE/Users/User/User';

import { IAccessRequestItemProps } from './AccessRequestItem.types';

interface IAccessRequestItemPresenter {
  request: ISecretChatAccessRequest;
  user: User | null;
  deviceOS: string;
}
export const useAccessRequestItemPresenter = (
  props: IAccessRequestItemProps
): IAccessRequestItemPresenter => {
  const presenter = useLocalObservable<IAccessRequestItemPresenter>(() => ({
    request: props.request,

    get user(): User | null {
      return Entities.usersStore.getUserById(presenter.request.userId);
    },

    get deviceOS(): string {
      const filteredDeviceDetails = [presenter.request.osName, presenter.request.osVersion].filter(
        Boolean
      );

      if (!filteredDeviceDetails.length) {
        return '';
      }
      return filteredDeviceDetails.join(' ');
    },
  }));

  useEffect(() => {
    presenter.request = props.request;
  }, [props.request]);

  return presenter;
};
